import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../client";
import type { IQuestion } from "../exam_papers/types";
import { QueryKeys } from "@/lib/query-keys";

export const useQueryGetAnswerRatio = (id: string) => {
  return useQuery({
    queryKey: QueryKeys.examProgress.getRatio(id),
    queryFn: () => apiGet<IQuestion[]>(`/exam_progress/${id}/ratio`),
    select: (data) => data.data,
  });
};
